import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(root)/lp/[...slug]/error.tsx");
